<vb-breadcrumb-one title="News" [disableTitle]="true"></vb-breadcrumb-one>

<div class="news-page">
    <div *ngIf="isLoading" class="vb-spinner-box vb-spinner-box--page">
        <vb-spinner size="xl" label="Loading news"></vb-spinner>
    </div>

    <!-- Empty / failed — vb-news-list carries the header when there's data,
         so these states bring their own. -->
    <div *ngIf="isNoData && !isLoading" class="news-page__fallback">
        <vb-page-header heading="News"></vb-page-header>
        <p class="news-page__message">
            {{ isFailed ? 'Failed to load news' : 'No News Found' }}
        </p>
    </div>

    <vb-news-list
        *ngIf="!isLoading && !isNoData"
        [articles]="articles"
        [dense]="isMobile"
        [page]="paginate.currentPage ?? 1"
        [totalPages]="paginate.totalPages ?? 0"
        [totalItems]="paginate.totalItems ?? 0"
        [perPage]="pageSize"
        [perPageOptions]="pageSizeOptions"
        (openArticle)="openArticle($event)"
        (pageChange)="setPage($event)"
        (perPageChange)="setPageSize($event)">
    </vb-news-list>
</div>
